<template>
  <header :class="[{ [$style.isFixed]: isFixed }, $style.header]">
    <div class="header__headerList d-flex justify-content-between align-items-center">
      <div class="header__left">
        <router-link :to="{ name: 'home' }">
          <img v-if="isFixed || isHomePage" class="header__logo d-lg-block d-none" src="@assets/dingbeauty-images/home/logo.svg" alt="" />
          <img v-else class="header__logo d-lg-block d-none" src="@assets/dingbeauty-images/home/logo_white.svg" alt="" />
          <img alt="logo" class="header__logo isMobile" src="@assets/dingbeauty-images/home/logo.svg" />
        </router-link>
      </div>
      <div class="header__right">
        <div class="burger d-lg-none d-block" @click="isMenuOpen = !isMenuOpen" @keydown="isMenuOpen = !isMenuOpen">
          <img v-if="isMenuOpen" style="width: 24px;" src="@assets/images/home/x-mark.svg" alt="" />
          <img v-else style="width: 24px;" src="@assets/images/home/menu-bar.svg" alt="" />
        </div>
        <div :class="{ isActive: isMenuOpen }" class="header__menuList justify-content-lg-end">
          <div v-for="(item, $index) in menuList" :key="$index" class="header__menuItem">
            <router-link :to="{ name: item.alias }" class="header__link" :class="{ 'is-home-page': isHomePage }">
              {{ item.title }}
            </router-link>
          </div>
          <div class="header__menuItem">
            <router-link :to="{ name: 'contact' }" class="dingbeauty-btn is-mobile">
              <img class="email-icon" src="@src/assets/dingbeauty-images/contact/icon_mail_white.svg" alt="" />專人聯繫</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import throttle from 'lodash/throttle'
export default {
  name:'TheHeader2',
  data() {
    return {
      isFixed: false,
      isMenuOpen: false,
      menuList: [
        {
          title: '方案價格',
          alias: 'price',
        },
        // {
        //   title: '初階方案',
        //   alias: 'basicPlan',
        // },
        // {
        //   title: '進階方案',
        //   alias: 'advancedPlan',
        // },
      ],
    }
  },
  computed: {
    isHomePage() {
      return this.$route.name === 'home'
    },
  },
  mounted() {
    this.checkMenuFixed()
    window.addEventListener(
      'scroll',
      throttle(() => {
        this.checkMenuFixed()
      }, 100)
    )
  },
  destroyed() {
    window.removeEventListener(
      'scroll',
      throttle(() => {
        this.checkMenuFixed()
      }, 100)
    )
  },
  methods: {
    checkMenuFixed() {
      const scrollTop = this.getScrollTop()
      this.isFixed = scrollTop > 150
    },
    getScrollTop() {
      let scrollTop = 0
      if (typeof window.pageYOffset !== 'undefined') {
        scrollTop = window.pageYOffset
      } else if (typeof document.compatMode !== 'undefined' && document.compatMode !== 'BackCompat') {
        scrollTop = document.documentElement.scrollTop
      } else if (typeof document.body !== 'undefined') {
        scrollTop = document.body.scrollTop
      }
      return scrollTop
    },
  },
}
</script>

<style lang="scss" module>
$color-primary: #e3c192;
.header {
  height: 122px;
  display: flex;
  align-items: center;
  position: relative;
  z-index: 999;
  position: fixed;
  top: 0;

  @include max-lg {
    position: fixed;
    width: 100vw;
    max-width: 100%;
    right: 0;
    left: 0;
    height: 70px;
    box-shadow: 0px 4px 15px rgba(84, 86, 98, 0.12);
    background: $color-white;
  }
  &.isFixed {
    position: fixed;
    // top: 0;
    right: 0;
    left: 0;
    width: 100vw;
    max-width: 100%;
    height: 90px;
    box-shadow: 0px 4px 15px rgba(84, 86, 98, 0.12);
    animation-name: slideIn;
    animation-duration: 0.5s;
    background: $color-white;
    @include max-lg {
      animation: none;
      height: 70px;
    }
    :global {
      .header {
        &__link {
          color: $color-text-1;
          &.router-link-active {
            color: $color-primary;
          }
        }
      }
    }
  }

  :global {
    .header {
      &__logo {
        width: 220px;
        height: 46px;

        @include max-lg {
          max-width: 180px;
          height: 33.19px;
        }

        &.isMobile {
          display: none;

          @include max-lg {
            display: block;
          }
        }
      }
      &__headerList {
        padding-left: 40px;
        padding-right: 40px;
        width: 100vw;
        max-width: 100%;
        position: relative;
        @include max-lg {
          padding-left: 20px;
          padding-right: 20px;
        }
      }
      &__menuList {
        display: flex;
        align-items: center;
        @include max-lg {
          flex-direction: column;
          width: 100vw;
          max-width: 100%;
          position: absolute;
          top: 56px;
          left: 0;
          right: 0;
          background-color: #ffffff;
          padding-left: 30px;
          padding-right: 20px;
          // padding-top: 45px;
          // padding-bottom: 60px;
          box-shadow: 0px 4px 15px rgba(84, 86, 98, 0.12);
          max-height: 0;
          overflow: hidden;
          transition: 0.8s;
          // position: relative;
          &:before {
            content: '';
            position: absolute;
            width: 90%;
            top: 0;
            left: 0;
            right: 0;
            height: 1px;
            margin: 0 auto;
            background-color: #edf0f4;
          }
        }
        &.isActive {
          max-height: 900px;
        }
      }
      &__menuItem {
        &:not(:last-child) {
          margin-right: 50px;
          @include max-lg {
            margin-right: 0;
          }
        }
        @include max-lg {
          padding-bottom: 15px;
          padding-top: 15px;
          margin-right: 0;
          width: 100%;
          text-align: center;
          &:first-child {
            margin-top: 45px;
          }
          &:last-child {
            margin-bottom: 60px;
          }
        }
      }
      &__link {
        padding: 15px 10px;
        color: $color-white;
        text-decoration: none;
        transition: 0.3s;
        font-weight: 500;
        &.router-link-active {
          position: relative;
          &:before {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            height: 5px;
            width: 5px;
            background: #fff;
            border-radius: 100px;
          }
        }
        @include max-lg {
          color: $color-text-1;
        }
        &:hover {
          color: $color-primary;
        }
      }
      &__right {
        .burger {
          font-size: 30px;
          color: $color-text-3;
          cursor: pointer;
        }
      }
    }
    .basebutton {
      @include max-lg {
        &.isMobile {
          background-color: $color-primary;
          color: #ffffff;
          box-shadow: none;
          margin-top: 10px;
          width: 100%;
        }
      }
    }

    @keyframes slideIn {
      0% {
        top: -90px;
      }
      100% {
        top: 0;
      }
    }

    .is-home-page.header__link {
      color: #0c1c30;
    }
  }
}
</style>
